import React from "react"
import { Table, TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody } from "material-ui"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import { IPayTypeBudget } from "../../models/data/PayTypeBudget"
import * as jobHelper from "../../helpers/jobHelper"

interface IProps {
    readonly: boolean
    payTypeBudgetItems: IPayTypeBudget[]
    selectedItems: IPayTypeBudget[]
    handleUpdate?(payTypeBudgetItem: IPayTypeBudget): void
    handleSelect?(payTypeBudgetItems: IPayTypeBudget[]): void
}
interface IState {
    selectedItems: IPayTypeBudget[]
    showTable: boolean
}

export default class JobDetailBudgetTable extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            selectedItems: [],
            showTable: true,
        }
        autobind(this)
    }

    handelOnCellClick(rowNumber, colId) {
        if (this.props.readonly) return
        const clickedItem = this.props.payTypeBudgetItems[rowNumber]
        if (colId === -1) {
            let selectedItems = this.state.selectedItems.slice()
            if (this.state.selectedItems.find(item => jobHelper.comparePayTypeBudgets(item, clickedItem))) {
                selectedItems = selectedItems.filter(item => !jobHelper.comparePayTypeBudgets(item, clickedItem))
            }
            else {
                selectedItems.push(clickedItem)
            }
            this.setSelectedItems(selectedItems)
        }
        else {
            this.props.handleUpdate(clickedItem)
        }
    }

    handleOnRowSelection(result) {
        result === "all" && this.setSelectedItems(this.props.payTypeBudgetItems.slice())
        result === "none" && this.setSelectedItems([])
    }

    setSelectedItems(selectedItems) {
        this.setState({ selectedItems, showTable: false }, () => this.setState({ showTable: true }))
        this.props.handleSelect &&
            this.props.handleSelect(selectedItems)
    }

    getPayTypeName(row: IPayTypeBudget) {
        if (row.RegularTime) {
            return "REG"
        } else if (row.OTTime) {
            return "OT"
        } else if (row.OT2Time) {
            return "OT2"
        } else {
            return row.PayTypeName
        }
    }

    render() {
        return (
            <Table
                allRowsSelected={this.props.payTypeBudgetItems.length === this.state.selectedItems.length}
                multiSelectable={!this.props.readonly}
                selectable={!this.props.readonly}
                onCellClick={this.handelOnCellClick}
                onRowSelection={this.handleOnRowSelection}
                style={{ backgroundColor: "none" }}
            >
                <TableHeader
                    displaySelectAll
                    adjustForCheckbox
                >
                    <TableRow>
                        <TableHeaderColumn style={styles.headerCol}>{strings.Pay_Type_Name}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>{strings.WeeklyHourlyBudget}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>{strings.WeeklyAmountBudget}</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody showRowHover={true} deselectOnClickaway={false} displayRowCheckbox>
                    {this.props.payTypeBudgetItems.map((row, index) =>
                        <TableRow
                            data-intercom-target={index === 0 && "Jobs-openJobDetails"}
                            key={index}
                            selected={this.state.selectedItems.find(item => jobHelper.comparePayTypeBudgets(item, row)) ? true : false}
                        >
                            <TableRowColumn style={styles.rowCol}>{this.getPayTypeName(row)}</TableRowColumn>
                            <TableRowColumn style={styles.rowCol}>{row.WeeklyBudgetInHours} hrs</TableRowColumn>
                            <TableRowColumn style={styles.rowCol}>${row.WeeklyBudgetAmount}</TableRowColumn>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        )
    }
}

const styles = {
    headerCol: {
        paddingLeft: 5,
        paddingRight: 5,
    },
    rowCol: {
        paddingLeft: 5,
        paddingRight: 5,
        cursor: "pointer"
    }
}
